import { TFunction } from "i18next";
import { confirmDialog, ConfirmDialogProps } from "primereact/confirmdialog";
import delete_icon from "../../assets/images/delete_confirmation.svg";

export default function deleteConfirmation(
  t: TFunction,
  props: ConfirmDialogProps
) {
  return confirmDialog({
    message: (
      <div className="flex flex-column align-items-center gap-5">
        <img src={delete_icon} width={100} height={100} alt="delete icon"></img>
        <span>
          <>{props.message}</>
        </span>
      </div>
    ),
    header: props.header,
    className:"custom-confirmation",
    rejectClassName: "p-button-secondary",
    rejectLabel: t("Cancel"),
    acceptLabel: t("Confirm"),
    accept: props.accept,
    reject: props.reject,
  });
}
